module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQwAAAAECAYAAAB7qAFKAAAAgElEQVRYhe3XsQrAIAxF0aSL0f//Tlfd0qEILTiYYkDx3VGUHjIEyjlnJUMiQjFGy5Phaq1USvn1VlWJmT9nq1p7wfoE61zrbONlubzy8LEs+sF6rtXDOLwwQghHD78FK6w7WL2MQwtDRCilNO3j73YYfgtWf6uq6Q+52+lz9TTeZUKaT9PdEpgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/color-no-dai.png
// module id = g0T2
// module chunks = 4